<template>
<main class="form-signin">
    <h1 class="h3 mb-3 fw-normal">Autentificare raportare<br> UMBGrup</h1>
    <p v-if="incorrectAuth"> Autentificare nereusita</p>
    <form @submit.prevent="login" id="plogin">
      <input v-model="username" type="tel" class="form-control"  placeholder="07xxxxxxxx" patern="0[0-9]{9}" required autofocus>
      <input v-model="password" v-if="!amuitatparola" id="parola" type="text" class="form-control" placeholder="Password" autocomplete="one-time-code">
    
    <button class="w-100 btn btn-lg btn-primary" id="baga" type="submit" ref="sbm">{{submit_text}}</button>
    <p class="mt-5 mb-3 text-muted"><small>sun&nbsp; &copy; 2017–2025
      <br>
      <b style="-webkit-text-fill-color:gainsboro; font-size: smaller;" hidden>icarcei@gmail.com</b>
    </small></p>
    
    </form>
    </main>
</template>

<script>
import axios from 'axios'
import {mapActions} from 'vuex'

export default {
    name: 'Login',
    data () {
        return {
            username: '',
            password: '',
            incorrectAuth: false,
            amuitatparola: true,
            submit_text: 'Cere parola',
        }
    },
    methods:{
        login:async function(){
            const {username, amuitatparola} = this;
            const panou = document.getElementById("loading");
            panou.style.display = 'flex';
            if (amuitatparola){
                const formData={username: username};
                try{
                    const resp = await axios.post('rapoarte_renew/', formData);
                    if(resp.data.ANS==='OK'){
                        alert(resp.data.MSG);
                        setTimeout(() => this.verifica(), 1)
                        this.amuitatparola = false;
                        
                    }

                }catch(error){
                    console.log(error)
                }
            }else{
                try{
                    //this.$store.commit('setAuthenticated_m');
                    const password = this.password.toLowerCase();
                    await this.$store.dispatch('login',{username, password})
                    this.$router.push("/acasa");
                  
                }catch(error){
                    this.incorrectAuth = true;
                    console.log(error)
                }
            }
            panou.style.display= 'none';
        },
        verifica: function(){
                document.getElementById("parola").required = ! this.amuitatparola;
                document.getElementById("baga").innerText = this.amuitatparola ? "Cere parola" : "Autentifica!";
        },
        ...mapActions({
            check: 'setAuthenticated'
        })

    },

    mounted(){
        this.$store.dispatch("logout");
    }

}
//auto input otp code
if ('OTPCredential' in window) {
  window.addEventListener('DOMContentLoaded', e => {
    console.log(e);
    const ac = new AbortController();
    const form = document.getElementById('plogin')
    if (form) {
      form.addEventListener('submit', e => {
        console.log(e)
        ac.abort();
      });
    }
    navigator.credentials.get({
      otp: { transport: ['sms'] },
      signal: ac.signal
    }).then(otp => {
      alert(otp.code);
      let input = document.getElementById('parola');
      input.value = otp.code.replace('#','').replace(' ','');
      //if (form) form.submit();
    }).catch(err => {
      console.log(err);
    });
  });
} else {
  //alert("Nu suporta otp")
}

</script>


<style scoped>

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="text"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  text-transform: lowercase;
}


.lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid #fff;
  border-color: #fff transparent #fff transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>